import CryptoJS from "crypto-js";
import type { ConfigurationEncode } from "./configurationEncode";

export const CryptoHelper = {
  encrypt: (encoder: ConfigurationEncode, plainText: string): string =>
    CryptoJS.AES.encrypt(
      plainText,
      CryptoJS.enc.Utf8.parse(encoder.key.substring(0, encoder.keyLength)),
      {
        iv: CryptoJS.enc.Utf8.parse(encoder.iv.substring(0, encoder.ivLength)),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(),

  decrypt: (encoder: ConfigurationEncode, encryptedText: string): string =>
    CryptoJS.AES.decrypt(
      encryptedText,
      CryptoJS.enc.Utf8.parse(encoder.key.substring(0, encoder.keyLength)),
      {
        iv: CryptoJS.enc.Utf8.parse(encoder.iv.substring(0, encoder.ivLength)),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8),
};
